module.exports = __webpack_public_path__ + "static/Constructionline-logo-white-ac377110108c56d74e8aa9e413a33e9e.png";